import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Historique
import Historique from "../pages/Historique/HistoriqueVueEmploi/HistoriqueVueEmploi"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"



// Cycle
import Cycle from "../pages/Cycle/Cycle"
import EditCycle from "../pages/Cycle/EditCycle"

// Niveau
import Niveau from "../pages/Niveau/Niveau"
import EditNiveau from "../pages/Niveau/EditNiveau"

import Tirage from "../pages/Tirage/Tirage"

// Specialite
import Specialite from "../pages/Specialite/Specialite"
import EditSpecialite from "../pages/Specialite/EditSpecialite"

// Groupe
import Groupe from "../pages/Groupe/Groupe"
import EditGroupe from "../pages/Groupe/EditGroupe"
import DetailGroupe from "../pages/Groupe/DetailGroupe"
import ViewGroupCour from "../pages/Groupe/ViewGroupCour"
import ViewGroupTD from "../pages/Groupe/ViewGroupTD"
import ViewGroupTP from "../pages/Groupe/ViewGroupTP"

// Module
import Module from "../pages/Modules/Module"
import EditModuleSpec from "../pages/Modules/EditModuleSpec"
import EditModule from "../pages/Modules/EditModule"
import DetailModuleSpecialite from "../pages/Modules/DetailModuleSpecialite"

// Matiere
import Matiere from "../pages/Matieres/Matiere"
import EditMatiere from "../pages/Matieres/EditMatiere"
import EditMatiereModule from "../pages/Matieres/EditMatiereModule"
import DetailMatiereModule from "../pages/Matieres/DetailMatiereModule"
import MatieresEnseignants from "../pages/Matieres/MatieresEnseignants"

// Enseignant
import Enseignant from "../pages/Enseignant/Enseignant"
import EditEnseignant from "../pages/Enseignant/EditEnseignant"
import DetailEnseignants from "../pages/Enseignant/DetailEnseignants"
import EnseignantsGroupes from "../pages/Enseignant/EnseignantsGroupes"
import FicheVoeux from "../pages/Enseignant/FicheVoeux"

// Grade Enseignant
import Grade from "../pages/Grades/Grade"
import EditGrade from "../pages/Grades/EditGrade"

// Statut Enseignant
import Statut from "../pages/Statuts/Statut"
import EditStatut from "../pages/Statuts/EditStatut"

// Diplome Enseignant
import Diplome from "../pages/Diplome/Diplome"
import EditDiplome from "../pages/Diplome/EditDiplome"
// Département
import Departement from "../pages/Departement/Departement"
import EditDepartement from "../pages/Departement/EditDepartement"
import EditAffectation from "../pages/Departement/EditAffectation"


// Etudiant
import Etudiant from "../pages/Etudiant/Etudiant"
import EditEtudiant from "../pages/Etudiant/EditEtudiant"
import DetailEtudiant from "../pages/Etudiant/DetailEtudiant"

// SchedulesEnseignants
import SchedulesEnseignants from "../pages/CalendarEnseignant/SchedulesEnseignants"
import AddScheduleEnseignant from "../pages/CalendarEnseignant/AddScheduleEnseignant"
import EmploiEnseignant from "../pages/CalendarEnseignant/EmploiEnseignant"

//emploi group
import EmploiGroup from "../pages/CalendarGroupes/EmploiGroup"
import SchedulesGroups from "../pages/CalendarGroupes/SchedulesGroups"

// Emploi salle
import ScheduleSalle from "../pages/CalendarSalle/ScheduleSalle"
import EmploiSalle from "../pages/CalendarSalle/EmploiSalle"

// Calendar Exam
import CalExam from "../pages/CalendarExamen/CalExam"
import ListMatieresExam from "../pages/CalendarExamen/ListMatieresExam"

// Calendar DS2
import CalDS2 from "../pages/DS2/CalDS2"
import ListMatieresDS2 from "../pages/DS2/ListMatieresDS2"

// Compostage
import Compostage from "../pages/Compostage/Compostage"
import CompostageCon from "../pages/Compostage/CompostageCon"
import ListMatieres from "../pages/Compostage/ListMatieres"
import ListSalle from "../pages/Compostage/ListSalle"

// Note examen
import NoteExamen from "pages/NoteExamen/NoteExamen"
import NoteExamenCon from "pages/NoteExamen/NoteExamenCon"
import ListMatieresNote from "../pages/NoteExamen/ListMatieresNote"
import ListEtudiantNote from "../pages/NoteExamen/ListEtudiantNote"

// DS2
import NoteDS2 from "pages/NoteDS2/NoteDS2"
import ListMatieresNoteDS2 from "../pages/NoteDS2/ListMatieresNoteDS2"
import ListEtudiantNoteDS2 from "../pages/NoteDS2/ListEtudiantNoteDS2"


// Surveillance
import Surveillance from "../pages/Surveillance/Surveillance"

import SurveillanceJour from "../pages/SurveillanceJour/SurveillanceJour"

//Salle
import Salle from "../pages/Salle/Salle"
import EditSalle from "../pages/Salle/EditSalle"
//Salle examen
import SalleExamen from "../pages/SalleExamen/Salle"
import EditSalleExamen from "../pages/SalleExamen/EditSalle"

//Demande
import AttestationPresence from "../pages/Demandes/AttestationPresence"

// note
import NoteDS from "pages/NoteDS/NoteDS"
import AddNoteDS from "pages/NoteDS/AddNoteDS"

// ListAbsence
import ListAbsence from "pages/ListAbsence/ListAbsence"
import EnseignantAbsence from "pages/ListAbsence/EnseignantAbsence"
import Seance from "pages/ListAbsence/Seance"
import EditAbsence from "pages/ListAbsence/EditAbsence"

//
import Rattrapage from "pages/Rattrapage/Rattrapage"


import AvisTest from "pages/Test/AvisTest"

// Espace Mastere
import ListInscription from "../pages/EspaceMastere/Inscription/ListInscription"
import FicheVoeuxEns from "pages/Enseignant/FicheVoeuxEns"
import AttestationPresenceArchive from "../pages/Demandes/AttestationPresenceArchive";
import PageAutorisation from "../pages/PageAutorisation";
import PlanEtude from "../pages/PlanEtude/PlanEtude";
import InstitutOrigin from "../pages/InstitutOrigin/InstitutOrigin";
import EditInstitutOrigin from "../pages/InstitutOrigin/EditInstitutOrigin";
import EditSpecialiteEnseignant from "../pages/SpecialiteEnseignant/EditSpecialiteEnseignant";
import SpecialiteEnseignant from "../pages/SpecialiteEnseignant/SpecialiteEnseignant";


///Gestion utilisateur

import User from "pages/GestionUtilisateur/User"
import DetailUser from "../pages/GestionUtilisateur/DetailUser";
import ModifUser from "../pages/GestionUtilisateur/ModifUser";
import Registre from "../pages/Registre/Registre";

import AvisAbsence from "../pages/AvisAbsence/AvisAbsence"
import EditAvisAbsence from "../pages/AvisAbsence/EditAvisAbsence"
import EditParametrageDs from "../pages/Test/EditParametrageDs";
import GroupeExamen from "../pages/GroupeExamen/GroupeExamen";
import EditGroupeExamen from "../pages/GroupeExamen/EditGroupeExamen";

import QuartExamen from "../pages/QuartExamen/QuartExamen";
import EditQuartExamen from "../pages/QuartExamen/EditQuartExamen";
import CalendrierSurveillance from "../pages/CalendrierSurveillance/CalendrierSurveillance";
import EditParametrageExamen from "../pages/ParametrageExamen/EditParametrageExamen";
import ParametrageExamen from "../pages/ParametrageExamen/ParametrageExamen";

///HISTORIQUE
import HistoriqueGrade from "../pages/Historique/HistoriqueGrade/HistoriqueGrade";
import HistoriqueStatus from "../pages/Historique/HistoriqueStatus/HistoriqueStatus";
import HistoriqueDiplome from "../pages/Historique/HistoriqueDiplome/HistoriqueDiplome";
import HistoriquePermutation from "../pages/Historique/HistoriquePermutation/HistoriquePermutation";
import HistoriqueSalle from "../pages/Historique/HistoriqueSalle/HistoriqueSalle";
import HistoriqueSpecialite from "../pages/Historique/HistoriqueSpecialite/HistoriqueSpecialite";
import HistoriqueMatiere from "../pages/Historique/HistoriqueMatiere/HistoriqueMatiere";
import HistoriqueModule from "../pages/Historique/HistoriqueModule/HistoriqueModule";
import HistoriqueModuleMatiere from "../pages/Historique/HistoriqueModuleMatiere/HistoriqueModuleMatiere";
import HistoriqueSeance from "../pages/Historique/HistoriqueSeance/HistoriqueSeance";
import HistoriqueGroupeExamen from "../pages/Historique/HistoriqueGroupeExamen/HistoriqueGroupeExamen";
import HistoriqueGroupeEnseignantMatiere
  from "../pages/Historique/HistoriqueGroupeEnseignantMatiere/HistoriqueGroupeEnseignantMatiere";
import DemandeTerrain from "../pages/DemandeTerrain/DemandeTerrain";
import HistoriqueActivationEnseignant
  from "../pages/Historique/HistoriqueActivationEnseignant/HistoriqueActivavtionEnseignant";
import HistoriqueDemandeTerrain from "../pages/Historique/HistoriqueDemandeTerrain/HistoriqueDemandeTerrain";
import HistoriqueVueEmploi from "../pages/Historique/HistoriqueVueEmploi/HistoriqueVueEmploi";
import HistoriqueModifCapaciteGroup
  from "../pages/Historique/HistoriqueModifCapaciteGroup/HistoriqueModifCapaciteGroup";
import HistoriqueEnseignant from "../pages/Historique/HistoriqueEnseignant/HistoriqueEnseignant";
import EditParametrageSessionOuverture from "../pages/ParametrageExamen/EditParametrageSessionOuverture";
import Semestre from "../pages/Semestre/Semestre";
import EditSemstre from "../pages/Semestre/EditSemstre";
import HistoriqueVueSurveillance from "../pages/Historique/HistoriqueVueSurveillance/HistoriqueVueSurveillance";
import ParametrageOrientation from "../pages/ParametrageOrientation/ParametrageOrientation"
import EditParametrageOrientation from "../pages/ParametrageOrientation/EditParametrageOrientation"
import Orientation from "../pages/ParametrageOrientation/Orientation"
import HistoriqueGroup from "../pages/Historique/HistoriqueGroup/HistoriqueGroup"
import GenerationAutoSem from "../pages/CalendarEnseignant/GenerationAutoSem"
import Generation from "../pages/CalendarEnseignant/Generation"

const authProtectedRoutes = [

  ///
  { path: "/GenerationAuto", component: Generation },
  { path: "/Orientation", component: Orientation },
  { path: "/ParametrageOrientation", component: ParametrageOrientation },
  { path: "/EditParametrageOrientation", component: EditParametrageOrientation },

  ///Semestre
  { path: "/Semestre", component: Semestre },
  { path: "/EditSemestre", component: EditSemstre },

  { path: "/AvisAbsence", component: AvisAbsence },
  { path: "/EditAvisAbsence", component: EditAvisAbsence },
  { path: "/EditParametrage", component: EditParametrageDs },

  { path: "/EditParametrageExamen", component: EditParametrageExamen },
  { path: "/EditParametrageSeesion", component: EditParametrageSessionOuverture},
  { path: "/ParametrageExamen", component: ParametrageExamen },
  // PageAutorisation
  { path: "/PageAutorisation", component: PageAutorisation },

  { path: "/DemandeTerrain", component: DemandeTerrain },
  // HISTORIQUE
  { path: "/historiqueGrade", component: HistoriqueGrade },
  { path: "/historiqueStatus", component: HistoriqueStatus },
  { path: "/historiqueDiplome", component: HistoriqueDiplome },
  { path: "/HistoriquePermutation", component: HistoriquePermutation },
  { path: "/HistoriqueSalle", component: HistoriqueSalle },
  { path: "/HistoriqueSpecialite", component: HistoriqueSpecialite },
  { path: "/HistoriqueMatiere", component: HistoriqueMatiere },
  { path: "/HistoriqueModule", component: HistoriqueModule },
  { path: "/HistoriqueModuleMatiere", component: HistoriqueModuleMatiere },
  { path: "/HistoriqueSeance", component: HistoriqueSeance },
  { path: "/HistoriqueGroupExamen", component: HistoriqueGroupeExamen },
  { path: "/HistoriqueGroupEnsMatiere", component: HistoriqueGroupeEnseignantMatiere },
  { path: "/HistoriqueActivationEnseignant", component: HistoriqueActivationEnseignant },
  { path: "/HistoriqueDemandeTerrain", component: HistoriqueDemandeTerrain },
  { path: "/HistoriqueVueEmploi", component: HistoriqueVueEmploi },
  { path: "/HistoriqueVueSurveillance", component: HistoriqueVueSurveillance },
  { path: "/HistoriqueModifCapaciteGroup", component: HistoriqueModifCapaciteGroup },
  { path: "/HistoriqueEnseignant", component: HistoriqueEnseignant },
  { path: "/HistoriqueGroup", component: HistoriqueGroup },
  // Registre
  { path: "/Registre", component: Registre },

  // Gestion Utilisateur
  { path: "/User", component: User },
  { path: "/DetailUser", component: DetailUser },
  { path: "/ModifUser", component: ModifUser },

  // profile
  { path: "/PlanEtude", component: PlanEtude },
  // Calendreier surveillance
  { path: "/CalendrierSurveillance", component: CalendrierSurveillance },

  { path: "/dashboard", component: Dashboard },
  // diplome
  { path: "/Diplome", component: Diplome },
  { path: "/EditDiplome", component: EditDiplome },
  // Quart examen
  { path: "/QuartExamen", component: QuartExamen },
  { path: "/EditQuartExamen", component: EditQuartExamen },

  // profile
  { path: "/profile", component: UserProfile },

  // Historique
  { path: "/Historique", component: Historique },

  // Cycle
  { path: "/Cycle", component: Cycle },
  { path: "/EditCycle", component: EditCycle },

  // Niveau
  { path: "/Niveau", component: Niveau },
  { path: "/EditNiveau", component: EditNiveau },

  // Specialite
  { path: "/Specialite", component: Specialite },
  { path: "/EditSpecialite", component: EditSpecialite },

  // Groupe
  { path: "/Groupe", component: Groupe },
  { path: "/EditGroupe", component: EditGroupe },
  { path: "/DetailGroupe", component: DetailGroupe },
  { path: "/ViewGroupCour", component: ViewGroupCour },
  { path: "/ViewGroupTD", component: ViewGroupTD },
  { path: "/ViewGroupTP", component: ViewGroupTP },

  // Module
  { path: "/Module", component: Module },
  { path: "/EditModuleSpec", component: EditModuleSpec },
  { path: "/EditModule", component: EditModule },
  { path: "/DetailModuleSpecialite", component: DetailModuleSpecialite },

  // Matiere
  { path: "/Matiere", component: Matiere },
  { path: "/EditMatiere", component: EditMatiere },
  { path: "/EditMatiereModule", component: EditMatiereModule },
  { path: "/DetailMatiereModule", component: DetailMatiereModule },
  { path: "/MatieresEnseignants", component: MatieresEnseignants },

  // Enseignant
  { path: "/Enseignant", component: Enseignant },
  { path: "/EditEnseignant", component: EditEnseignant },
  { path: "/DetailEnseignants", component: DetailEnseignants },
  { path: "/EnseignantsGroupes", component: EnseignantsGroupes },
  { path: "/FicheVoeux", component: FicheVoeux },
  { path: "/FicheVoeuxEns", component: FicheVoeuxEns },

  // Grade Enseignant
  { path: "/Grade", component: Grade },
  { path: "/EditGrade", component: EditGrade },

  // Statut Enseignant
  { path: "/Statut", component: Statut },
  { path: "/EditStatut", component: EditStatut },

  // Département
  { path: "/Departement", component: Departement },
  { path: "/EditDepartement", component: EditDepartement },
  { path: "/EditAffectation", component: EditAffectation },


  // Etudiant
  { path: "/Etudiant", component: Etudiant },
  { path: "/EditEtudiant", component: EditEtudiant },
  { path: "/DetailEtudiant", component: DetailEtudiant },

  // SchedulesEnseignants
  { path: "/SchedulesEnseignants", component: SchedulesEnseignants },
  { path: "/AddScheduleEnseignant", component: AddScheduleEnseignant },
  { path: "/EmploiEnseignant", component: EmploiEnseignant },

  //emploi group
  { path: "/EmploiGroup", component: EmploiGroup },
  { path: "/SchedulesGroups", component: SchedulesGroups },

  //emploi salle
  { path: "/ScheduleSalle", component: ScheduleSalle },
  { path: "/EmploiSalle", component: EmploiSalle },

  // Calendar Exam
  { path: "/CalExam", component: CalExam },
  { path: "/ListMatieresExam", component: ListMatieresExam },

  // Calendar ds2
  { path: "/CalDS2", component: CalDS2 },
  { path: "/ListMatieresDS2", component: ListMatieresDS2 },

  // Compostage
  { path: "/Compostage", component: Compostage },
  { path: "/CompostageCon", component: CompostageCon },
  { path: "/ListMatieres", component: ListMatieres },
  { path: "/ListSalle", component: ListSalle },

  // Surveillance
  { path: "/Surveillance", component: Surveillance },

  { path: "/SurveillanceJour", component: SurveillanceJour },

  //Salle
  { path: "/Salle", component: Salle },
  { path: "/EditSalle", component: EditSalle },
  //Salle
  { path: "/SalleExamen", component: SalleExamen },
  { path: "/EditSalleExamen", component: EditSalleExamen },
  //Groupe examen
  { path: "/GroupeExamen", component: GroupeExamen },
  { path: "/EditGroupeExamen", component: EditGroupeExamen },
  //insrtitut origin
  { path: "/InstitutOrigin", component: InstitutOrigin },
  { path: "/EditInstitutOrigin", component: EditInstitutOrigin },
  //Spécialités enseignant
  { path: "/SpécialitésEnseignant", component: SpecialiteEnseignant },
  { path: "/EditSpécialitésEnseignant", component: EditSpecialiteEnseignant },

  //Demande
  { path: "/AttestationPresence", component: AttestationPresence },
  { path: "/AttestationPresenceArchive", component: AttestationPresenceArchive },

  // note
  { path: "/NoteDS", component: NoteDS },
  { path: "/AddNoteDS", component: AddNoteDS },
// note
  { path: "/NoteDS2", component: NoteDS2 },
  // { path: "/AddNoteDS", component: AddNoteDS },

  // Absence
  { path: "/ListAbsence", component: ListAbsence },
  { path: "/EnseignantAbsence", component: EnseignantAbsence },
  { path: "/Seance", component: Seance },
  { path: "/EditAbsence", component: EditAbsence },

  //
  { path: "/Rattrapage", component: Rattrapage },

  { path: "/Tirage", component: Tirage },

  { path: "/AvisTest", component: AvisTest },

  // NoteExamenPrincipale
  { path: "/NoteDS2", component: NoteDS2 },
  { path: "/ListMatieresNoteDS2", component: ListMatieresNoteDS2 },
  { path: "/ListEtudiantNoteDS2", component: ListEtudiantNoteDS2 },

    // DS2
    { path: "/NoteExamen", component: NoteExamen },
    { path: "/NoteExamenCon", component: NoteExamenCon },
    { path: "/ListMatieresNote", component: ListMatieresNote },
    { path: "/ListEtudiantNote", component: ListEtudiantNote },
  

  // List Inscription
  { path: "/ListInscription", component: ListInscription },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/login" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
]

export { publicRoutes, authProtectedRoutes }
